import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Modal from '../common/utils/Modal';
import axios from 'axios';
import MusicDownload from '../common/MusicCommonComponents/MusicDownload';

const MusicPlayer = ({ track, onPause, onClose, token, user_subscribed_status }) => {

  
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const audioRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);
  const [showModal, setShowModal] = useState(false); 

  useEffect(() => {
    if (!track) return;

    // Create or update the audio instance
    if (!audioRef.current) {
      audioRef.current = new Audio(track.url);
    } else {
      audioRef.current.src = track.url; // Update the audio source
      audioRef.current.load();
      audioRef.current.play().catch((error) => console.error('Playback error:', error));
      setIsPaused(false);
    }

    const audio = audioRef.current;

    audio.addEventListener('loadedmetadata', () => {
      setDuration(audio.duration);
    });

    audio.addEventListener('timeupdate', () => {
      setCurrentTime(audio.currentTime);
    });

    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    };
  }, [track]);

  const handlePause = () => {
    if (audioRef.current) {
      audioRef.current.pause(); // Pause the audio
      setIsPaused(true);
    }
    if (onPause) {
      onPause(); // Trigger the onPause callback if provided
    }
  };

  const handlePlay = () => {
    if (audioRef.current) {
      audioRef.current.play();
      setIsPaused(false); 
    }
  };

  const handleSeek = (event) => {
    const seekTime = (event.target.value / 100) * duration;
    if (audioRef.current) {
      audioRef.current.currentTime = seekTime;
    }
  };

  const handleDownloadClick = async (event) => {
    if (!token) {
      event.preventDefault(); 
      setShowModal(true); 
    } else if (!user_subscribed_status) {
      event.preventDefault(); 
      window.location.to = "/licenses"; 
    } else {
      // Proceed with download tracking via API
      try {
        // Send a POST request to track the download
        await axios.post(process.env.REACT_APP_API_KEY + '/api/save-download-music', {
          music_id: track.id, 
          // user_id: 1, 
        }, {
          headers: {
            'Authorization': `Bearer ${token}`, 
          },
        });
         
        window.location.href = track.url; 
      } catch (error) {
        console.error('Error tracking download:', error);
       
      }
    }
  };
  const closeModal = () => setShowModal(false);
  
  // new add
  const formatTime = (time) =>{
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60).toString().padStart(2, '0');
    return `${minutes}:${seconds}`;}

  const progressPercentage = (currentTime / duration) * 100 || 0;

  return (
    <div className="play-area">
      <div className="player-left">
        <div className="play-tab">
          <button onClick={isPaused ? handlePlay : handlePause}>
            <img src={isPaused ? '/assets/img/play-ico.svg' : '/assets/img/pause-ico.svg'}
              alt={isPaused ? 'Play' : 'Pause'} />
          </button>
        </div>
        <div className="desc-tab">
          <h4>{track.title}</h4>
          <div className="play-time">
            {formatTime(currentTime)} / {formatTime(duration)}
          </div>
        </div>
      </div>

      <div className="player-mid">
        <div className="controls">
          <input
            min={0}
            max={100}
            step="0.1"
            type="range"
            // value={(currentTime / duration) * 100 || 0}
            value={progressPercentage}
            onChange={handleSeek}
            style={{
              background: `linear-gradient(to right, rgb(251 191 36) ${progressPercentage}%, rgb(255 255 255) ${progressPercentage}%)`,
              height: '8px',
              width: '100%',
              borderRadius: '5px',
              appearance: 'none',
              outline: 'none',
            }}
          />
        </div>
      </div>

      <div className="player-right">
      <div className="download-tab">
          <Link to={track.url} download onClick={handleDownloadClick}>
            <img src="/assets/img/download-ico.svg" alt="Download" />
          </Link>
          <span className="sr-only">Download</span>
        </div>

        {/* <MusicDownload track={track} user_subscribed_status={user_subscribed_status}/> */}

        <div className="cart-tab">
          <Link t>
            <img src="/assets/img/cart-ico.svg" alt="Buy" />
          </Link>
          <span className="sr-only">Buy a license</span>
        </div>
        <div className="close-tab" onClick={onClose}>
          <Link >
            <img src="/assets/img/close-ico.svg" alt="Close" />
          </Link>
          <span className="sr-only">Close</span>
        </div>
      </div>
      {showModal && <Modal
        show={showModal}
        handleClose={closeModal}
        logInHandler={() => (window.location.to = "/login")}
        pathName="music"
      />}
    </div>
  );
};

export default MusicPlayer;
